module.exports = __webpack_public_path__ + "media/images/athletes/1679-7e202e5620b96e5b52732bb5ce112b87.png";